import validate from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.17.6_@types+node@24.0.15_@vue+compiler-sfc@3.5.17_eslint@9.31.0_rollup@4.45.1_sa_30461cca56061039e3e1df146f09011e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.17.6_@types+node@24.0.15_@vue+compiler-sfc@3.5.17_eslint@9.31.0_rollup@4.45.1_sa_30461cca56061039e3e1df146f09011e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-to-landing-page": () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/middleware/redirect-to-landing-page.ts")
}